const blogFilterNode = document.querySelector('[data-blog-filter]');
const blogContentNode = document.querySelector('[data-blog-content]');

const changeBlogFilter = (e) => {
  const selectedBlogId = e.target.id;
  const contentItems = blogContentNode.querySelectorAll('[data-blog]');

  contentItems.forEach(item => {
    if (selectedBlogId === 'all') {
      item.style.display = 'block';
    } else if (item.dataset.blog !== selectedBlogId) {
      item.style.display = 'none';
    } else {
      item.style.display = 'block';
    }
  });
};

const radioButtons = blogFilterNode.querySelectorAll('input[type="radio"]');
radioButtons.forEach(radio => {
  radio.addEventListener('change', changeBlogFilter);
});